module.exports = __webpack_public_path__ + "static/img/Peter_Wright_mobile.4a18e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Peter_Wright_mobile.jpg
// module id = MFhF
// module chunks = 0